// packages import
import { Autocomplete, TextField } from '@mui/material'
import { FC, useContext } from 'react'

// others
import { BillStatus } from '../../../../../generated'
import { FinalBillsContext } from '../../../../context/FinalBillsContext'
import { FINAL_BILL_STATUSES, VOID_BILL_STATUSES } from '../../../../constants'
import { formatStatus } from '../../../../utils/billing'

interface StatusOption {
  value: string
  label: string
}

const voidBillStatuses = VOID_BILL_STATUSES.filter(
  status => status !== BillStatus.Void && status !== BillStatus.Archived
)
const finalBillStatuses= ['all',...FINAL_BILL_STATUSES, ...voidBillStatuses]
const statusOptions: StatusOption[] = finalBillStatuses.map(status => ({
  value: status,
  label: formatStatus(status)
}))

const StatusFilter: FC = () => {
  const { filters, setFilters } = useContext(FinalBillsContext)

  const selectedStatus = statusOptions.find(status => status.value === filters.status) || null

  const handleStatusChange = (value: StatusOption | null) => {
    setFilters({ status: value?.value as BillStatus | 'all' | undefined })
  }

  return (
    <Autocomplete
      sx={{ minWidth: 140 }}
      options={statusOptions}
      value={selectedStatus}
      onChange={(_, value) => handleStatusChange(value)}
      getOptionLabel={option => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={params => <TextField {...params} label="Status" />}
    />
  )
}

export default StatusFilter
